export default {
  calendar: {
    today: 'Dzisiaj',
    tomorrow: 'Jutro',
    asap: 'Jak najszybciej',
  },
};
